import { Grid } from '@react/chakra';

import type { JSX } from 'react';

import { PostSkeleton } from './components';

export function PostListSkeleton(): JSX.Element {
  return (
    <Grid
      gap={6}
      autoRows='1fr'
      templateColumns={{
        md: 'repeat(3, 1fr)',
        sm: 'repeat(2, 1fr)',
        base: 'repeat(1, 1fr)',
      }}
    >
      {Array.from({
        length: 3,
      }).map((_, index) => {
        return <PostSkeleton key={index} />;
      })}
    </Grid>
  );
}
